/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { GetAlertsQuery } from '../models/alerts/get-alerts.query';
import { GetAlertsResponse } from '../models/alerts/get-alerts.response';

@Injectable({
  providedIn: 'root',
})
export class AlertApi {
  constructor(private http: HttpClient) {}

  getAlertMessages(query: GetAlertsQuery = {}): Observable<GetAlertsResponse> {
    return this.http.get<GetAlertsResponse>(`${environment.servicesApiUrl}/api/v3/alert/messages`, {
      params: { ...(query.organisationId ? { organisationId: query.organisationId } : {}) },
    });
  }
}
